import React from 'react';
import Articles from '../Home/Articles/Articles';
import Header from '../Home/Header/Header';

const Home = () => {
    return (
        <div>
            <Header/>
            <Articles/>
        </div>
    );
};

export default Home;